const ENTITIES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };

/** Escapa texto para interpolação segura em HTML. */
export function esc(value: unknown): string {
  return String(value ?? '').replace(/[&<>"]/g, (c) => ENTITIES[c]!);
}

export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Elemento #${id} não encontrado`);
  return el as T;
}
